import { __assign } from "tslib";
import { connect } from 'react-redux';
import Device from '../components/Device';
import { screenResized } from '../actionCreators';
import { isInAnnotationMode } from '../selectors/annotation';
import { getFrame, getOrientation } from '../selectors/project';
import { getDimensions } from '../selectors/device';
import { isInHandoffMode } from '../selectors/handoff';
var mapStateToProps = function (state) { return (__assign(__assign({ statusBar: state.project.config.statusBar, orientation: getOrientation(state), dimensions: getDimensions(state), isShowingHotspots: state.hotspots, backgroundColour: state.project.config.backgroundColour, hotspot: null, isMobile: state.deviceDetection.isMobile, isWeb: state.project.config.isWeb, isEmbedded: state.project.isEmbedded, isFrameless: state.project.isFrameless, isInAnnotationMode: isInAnnotationMode(state), isInHandoffMode: isInHandoffMode(state), isInTheExploreView: state.project.isInTheExploreView }, state.project.config.device), { frame: getFrame(state) })); };
var mapDispatchToProps = function (dispatch) { return ({
    onScreenResize: function (renderedScreenDimensions) {
        return dispatch(screenResized(renderedScreenDimensions));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(Device);
